import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig
} from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'angular-highcharts';
import dayjs from 'dayjs/esm';
import { combineLatest, forkJoin } from 'rxjs';
import {
  FeatureItemFlatNode,
  FeatureItemNode,
  Hierarchy,
  TagParameters
} from '../../../../models/index';
import {
  CommonService,
  EnergyService,
  PlantServiceService,
  SiteService
} from '../../../../services/index';
import {
  AppUtils,
  Constants,
  Highcharts$,
  WarningDialog
} from '../../../../shared/index';
import { DataTagComponent } from '../data-tag/data-tag.component';
@Component({
  selector: 'app-real-time',
  templateUrl: './real-time.component.html',
  styleUrls: ['./real-time.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: Constants.DATE_RANGES_PROVIDER_FORMAT
    }
  ]
})
export class RealTimeComponent
  extends Hierarchy
  implements OnInit, AfterViewInit, OnDestroy
{
  // eslint-disable-next-line @typescript-eslint/member-ordering
  @ViewChild('tree') tree;
  siteId: string;
  siteName: string;
  startDate: string;
  endDate: string;
  isST_load: boolean;
  isMeter: undefined | boolean = undefined;
  isFirstLoaded = true;
  shifts: any;
  dateRange: any;
  alwaysShowCalendars: boolean;
  ranges: any = {
    // 'Today': [Moment$(), Moment$()],
    Yesterday: [dayjs().subtract(1, 'days'), dayjs().subtract(1, 'days')],
    'Last 7 Days': [dayjs().subtract(6, 'days'), dayjs()]
    // 'Last 30 Days': [Moment$().subtract(29, 'days'), Moment$()],
    //  'This Month': [Moment$().startOf('month'), Moment$().endOf('month')],
    // 'Last Month': [Moment$().subtract(1, 'month').startOf('month'), Moment$().subtract(1, 'month').endOf('month')]
  };
  totalEnergy = '';
  columnchart: Chart;
  currentNode: {
    nodeData: any;
    metersId: any;
    nodeTitle: string;
    nodeType: string;
    loadId: string;
    meterId: string;
    loadRId: string;
    kwRating: any;
  } = Object.assign({});

  displayUpdateTagAlert = true;
  tagParameters: TagParameters;
  isNotViewFull = true;
  buttons: any;
  langData: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private activeRoute: ActivatedRoute,
    private plantService: PlantServiceService,
    private siteService: SiteService,
    private commonService: CommonService,
    public dialog: MatDialog,
    private energyService: EnergyService,
    public translate: TranslateService
  ) {
    super();
    this.tagParameters = new TagParameters();
    this.alwaysShowCalendars = true;
    this.dateRange = {
      startDate: dayjs().subtract(1, 'days'),
      endDate: dayjs().subtract(1, 'days')
    };
    this.translate
      .stream('energy.realTime.subStream')
      .subscribe((subStream: any) => {
        this.langData = subStream;
      });
    this.siteName = localStorage.getItem('siteName');
  }
  ngOnInit() {
    // Combine them both into a single observable
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    // Subscribe to the single observable, giving us both
    urlParams.subscribe((routeParams) => {
      this.siteId = routeParams.siteId;
      //  this.plantService.getSiteDetail(this.siteId).subscribe(data => {
      //    this.siteName = data.;
      //  });
      forkJoin([
        this.plantService.getShiftsBySiteId(this.siteId),
        this.siteService.getTreeConfiguration(this.siteId, ['treeData'])
      ]).subscribe(([shifts, treeConfig]) => {
        this.shifts = shifts;
        this.dataSource.data = [];
        if (treeConfig !== undefined && treeConfig.treeData !== undefined) {
          // Data api is wrong. Can not use checkbox
          const dataPaser = JSON.parse(treeConfig.treeData);
          this.dataSource.data = this.buildFileTree(
            dataPaser[0],
            this.dataSource.data,
            null
          );
          this.tree.treeControl.expandAll();
          this.getFirstLoad(this.dataSource.data);
          this.processDataAndDrawChart();
        }
      });
    });
  }
  ngAfterViewInit(): void {
    this.tree?.treeControl?.expandAll();
    // collapseAll
    const seft = this;
    this.buttons = Highcharts$.getOptions().exporting.buttons;
    Highcharts$.setOptions({
      exporting: {
        buttons: {
          contextButton: {
            menuItems: this.buttons.contextButton.menuItems.slice(0, 2)
          }
        }
      }
    });
    document.addEventListener('fullscreenchange', function () {
      if (seft.columnchart && seft.columnchart.ref) {
        seft.columnchart.ref.update({
          exporting: {
            buttons: {
              contextButton: {
                menuItems: seft.isNotViewFull
                  ? seft.buttons.contextButton.menuItems.slice(1, 2)
                  : seft.buttons.contextButton.menuItems.slice(0, 2)
              }
            }
          }
        });
      }
      seft.isNotViewFull = !seft.isNotViewFull;
    });
  }
  ngOnDestroy() {
    document.removeEventListener('fullscreenchange', function () {});
  }
  buildFileTree(
    obj: any,
    nodes: FeatureItemNode[],
    currentSelected: FeatureItemFlatNode
  ): FeatureItemNode[] {
    const node = new FeatureItemNode();
    node.title = obj.title;
    node.id = obj.id;
    node.nodeType = obj.nodeType;
    node.subType = obj.subType;
    node.processRId = obj.processRId !== undefined ? obj.processRId : 'NA';
    node.meterId = obj.meterId !== undefined ? obj.meterId : 'NA';
    node.loadId = obj.loadId !== undefined ? obj.loadId : 'NA';
    node.loadRId = obj.loadRId !== undefined ? obj.loadRId : 'NA';
    node.kwRating = obj.kwRating;
    // node.selected = obj.state.selected;
    if (currentSelected != null && currentSelected.id === obj.id) {
      node.selected = true;
    }
    if (obj.nodes.length > 0) {
      node.nodes = [];
      obj.nodes.forEach((element) => {
        node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
      });
    }
    return nodes.concat(node);
  }
  /** Toggle the feature item selection. Select/deselect all the descendants node */
  public featureItemSelectionToggle(node: FeatureItemFlatNode): void {
    this.setCurrentNode(node);
    this.processDataAndDrawChart();
  }
  /** Toggle a leaf feature item selection. Check all the parents to see if they changed */
  public featureLeafItemSelectionToggle(node: FeatureItemFlatNode): void {
    this.setCurrentNode(node);
    this.processDataAndDrawChart();
  }
  private getAllMetersIdOfNode = (node: any, metersId: any) => {
    if (node.meterId !== 'NA') {
      metersId.push(node.meterId);
    }
    if (node.nodes !== undefined && node.nodes.length > 0) {
      for (let i = 0; i < node.nodes.length; i++) {
        metersId = this.getAllMetersIdOfNode(node.nodes[i], metersId);
      }
    }
    return metersId;
  };
  private getFirstLoad = (tree: any) => {
    const firstLeaf = this.getFirstLeafOfTree(tree);
    if (
      typeof firstLeaf.is_ST_Load !== 'undefined' &&
      firstLeaf.is_ST_Load != null &&
      firstLeaf.is_ST_Load
    ) {
      this.isST_load = true;
    } else {
      this.isST_load = false;
    }
    this.setCurrentNode(firstLeaf);
    const node = document.getElementById(firstLeaf.title);
    node.dispatchEvent(new Event('click'));
  };
  private getFirstLeafOfTree = (tree: any, conditions: any = undefined) => {
    let result;
    if (tree !== undefined) {
      for (let i = 0; i < tree.length; i++) {
        if (this.hasChildNode(tree[i])) {
          result = this.getFirstLeafOfTree(tree[i].nodes, conditions);
        } else {
          let conditionEvaluated = true;
          if (conditions !== undefined) {
            const propNames = Object.keys(conditions);
            for (let j = 0; j < propNames.length; j++) {
              conditionEvaluated =
                conditionEvaluated &&
                tree[i][propNames[j]] === conditions[propNames[j]];
              if (conditionEvaluated === false) {
                break;
              }
            }
          }
          if (tree[i].loadId !== undefined && conditionEvaluated) {
            result = tree[i];
            break;
          } else {
            continue;
          }
        }
        if (result !== undefined) {
          break;
        }
      }
    }
    return result;
  };
  private hasChildNode = (branch: any): boolean => {
    return branch.nodes === undefined || branch.nodes.length === 0
      ? false
      : true;
  };
  private setCurrentNode = (node: FeatureItemNode | FeatureItemFlatNode) => {
    this.isST_load = true;
    this.currentNode.nodeData = node;
    const metersId = this.getAllMetersIdOfNode(node, []);
    this.currentNode.metersId = AppUtils.uniqueArray(metersId);
    this.currentNode.nodeTitle = node.title;
    this.currentNode.nodeType = node.nodeType;
    // this.currentNode.loadId = node.loadId;
    // this.currentNode.loadRId = node.loadRId;
    // this.currentNode.kwRating = node.kwRating;
    if (node.nodeType === Constants.NODE_TYPE.METER) {
      this.isMeter = true;
      this.currentNode.meterId = node.meterId;
      this.currentNode.loadId = node.meterId;
      this.isST_load = false;
    } else if (node.nodeType === Constants.NODE_TYPE.LOAD) {
      this.isMeter = false;
      this.isST_load = false;
      this.currentNode.meterId = node.meterId;
      this.currentNode.loadId = node.loadId;
      this.currentNode.loadRId = node.loadRId;
      this.currentNode.kwRating = node.kwRating;
      if (node.subType !== undefined && node.subType === 'StratificationTank') {
        this.isST_load = true;
      }
    }
  };
  public onChangeDateRange = () => {
    if (this.commonService.isLaterThanCurentDate(this.dateRange.endDate)) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }
    if (
      this.isFirstLoaded === false &&
      !this.commonService.isNullOrUndefined(this.siteId)
    ) {
      this.processDataAndDrawChart();
    }
  };
  datesUpdated(event) {
    // this.processDataAndDrawChart();
  }
  private transformDate = () => {
    this.startDate = dayjs(this.dateRange.startDate).format(
      Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
    );
    this.endDate = dayjs(this.dateRange.endDate).format(
      Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
    );
  };
  private processDataAndDrawChart = () => {
    this.isFirstLoaded = false;
    if (this.isST_load === false) {
      this.transformDate();
      // Validate date range
      // Admin Users can view data for > 10 Days
      // Site Users cannot View data > 10 Days
      if (
        dayjs(this.dateRange.endDate).diff(
          dayjs(this.dateRange.startDate),
          'days'
        ) >= 10
      ) {
        this.onOpenAlertBox(
          this.translate.instant(Constants.DATE_LIMIT_10_DAYS)
        );
      } else {
        this.energyService
          .getRealtimeData(
            this.siteId,
            this.startDate,
            this.endDate,
            this.currentNode.meterId,
            this.currentNode.loadId
          )
          .subscribe((data) => {
            this.tagParameters.loadID = this.currentNode.loadId;
            this.tagParameters.loadName = this.currentNode.nodeTitle;
            this.tagParameters.loadRID = this.currentNode.loadRId;
            const tags =
              data.DataTags == null || data.DataTags === undefined
                ? []
                : data.DataTags;
            const fuelConsumption =
              data.fuelConsumption == null || data.fuelConsumption === undefined
                ? []
                : data.fuelConsumption;
            this.drawRealTimeInfoChart(
              data.realtimepower,
              tags,
              fuelConsumption
            );
            this.calTotalEnergyAndShow(data.realtimepower, false);
          });
      }
    } else {
      // Show message box
      this.onOpenAlertBox(this.langData.errDate);
    }
  };
  private drawRealTimeInfoChart = (
    data: any,
    tags: any,
    fuelConsumption: any
  ) => {
    this.columnchart = new Chart(null);
    let fromDate = '';
    let toDate = '';
    if (data.length <= 0) {
      fromDate = this.startDate;
      toDate = this.endDate;
    } else {
      fromDate = dayjs(data[0].x).format(
        Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
      );
      toDate = dayjs(data[data.length - 1].x).format(
        Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
      );
    }

    const fromTime = dayjs(data[0].x).format(
      Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_1
    );
    const toTime = dayjs(data[data.length - 1].x).format(
      Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_1
    );

    const self = this;
    const option = this.getAreaChartConfigOption();
    // eslint-disable-next-line max-len
    option.title.text = `${this.langData.graphTitle} ${fromTime} ${
      this.langData.to
    } ${toTime} ${
      this.currentNode.nodeTitle === undefined
        ? ''
        : this.langData.at + ' ' + this.currentNode.nodeTitle
    }`;
    const dataTagSeriesOptions = {
      name: this.langData.dataTags,
      lineWidth: 0,
      data: [],
      yAxis: 'DataTags',
      states: {
        hover: {
          lineWidthPlus: 0
        }
      },
      marker: {
        enabled: true,
        symbol: 'url(./assets/img/data_tag_redflag.png)'
      }
    };
    const fuelConsumptionYAxis = {
      id: 'fuelConsumption',
      title: {
        text: this.langData.litre
      },
      opposite: true
    };
    const fuelConsumptionSeriesOptions = {
      name: this.langData.fuelTitle,
      showInLegend: true,
      data: [],
      yAxis: 'fuelConsumption'
    };
    const addDataToSeries = () => {
      if (option.series[0] !== undefined) {
        option.series[0].data = data;
      }
      if (option.series[1] !== undefined && tags.length > 0) {
        option.series[1].data = tags;
      } else if (option.series[1] !== undefined && fuelConsumption.length > 0) {
        option.series[1].data = fuelConsumption;
      }
      if (option.series[2] !== undefined) {
        option.series[2].data = fuelConsumption;
      }
    };
    if (tags.length > 0) {
      if (option.series.length <= 1) {
        option.series.push(<any>dataTagSeriesOptions);
      }
      addDataToSeries();
    } else {
      if (option.series.length > 1) {
        // Remove Data Tag Series
        const seriesArr = option.series;
        seriesArr.splice(1, 1);
        option.series = seriesArr;
      }
      addDataToSeries();
    }
    if (fuelConsumption.length > 0) {
      if (option.yAxis.length <= 2) {
        option.yAxis.push(<any>fuelConsumptionYAxis);
      }
      if (option.series.length <= 2) {
        option.series.push(fuelConsumptionSeriesOptions);
      }
      addDataToSeries();
    } else {
      if (option.yAxis.length > 2) {
        const yaxisArr = option.yAxis;
        yaxisArr.splice(2, 1);
        option.yAxis = yaxisArr;
      }
      if (option.series.length > 2) {
        // Remove Fuel Consumed Series
        const seriesArr = option.series;
        seriesArr.splice(2, 1);
        option.series = seriesArr;
      }
      addDataToSeries();
    }
    option.xAxis.events = {
      afterSetExtremes: function (event) {
        let resetGraph = false;
        // if (event.userMax) {
        //   resetGraph = true;
        self.calTotalEnergyAndShow(this.series[0].points, resetGraph);
        // } else {
        //   self.calTotalEnergyAndShow(this.series[0].points, resetGraph);
        // }
      }
    };
    // option.plotOptions.series.point.events.click =
    //   this.customRealTimeInfoDataPointClick;
    this.columnchart = new Chart(<any>option);
  };
  private customRealTimeInfoDataPointClick = (event: any) => {
    const point = event.point; // series.name
    if (point.name !== 'Data Tags') {
      const tagtxtime = dayjs(point.x).format(
        Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_1
      );
      const paramName = 'realtimepower';
      const paramValue = point.y;
      const paramUnit = ' kW';
      this.setTagDetails(
        tagtxtime,
        paramName,
        paramValue,
        paramUnit,
        'realTimeInfo',
        ''
      );
      // Get existing Data Tags At this point
      // SiteService.fetchtaggedData($scope.siteId, null, null, $scope.tagParameters).then(function(data){
      //   $scope.taggedData = data;
      // });
      if (!this.isMeter) {
        // Open Modal
        const dialogConfig: MatDialogConfig = {
          // height: '80%',
          width: '70%',
          data: {
            tagParameters: this.tagParameters,
            fromDate: this.startDate,
            toDate: this.endDate
          }
        };
        // Open View Existing Tags Accordion
        this.dialog.open(DataTagComponent, dialogConfig);
        // Open View Existing Tags Accordion
        // this.dialog.open(DataTagComponent, dialogConfig);
        //     this.siteService.fetchTaggedData(this.tagParameters.siteID,
        //       this.startDate,
        //       this.endDate, this.tagParameters)
        //       .subscribe(res => {
        //         const tagData = res;
        //         const dialogConfig: MatDialogConfig = {
        //            height: '80%',
        //            width: '70%',
        //           data: { tagParameters: this.tagParameters, fromDate: this.startDate, toDate: this.endDate }
        //         };
        //   });
      } else {
        this.onOpenAlertBox(this.langData.errTagging);
      }
    }
  };
  // eslint-disable-next-line @typescript-eslint/member-ordering
  // customRealTimeInfoDataPointClick = {

  //   click: function() {
  //     console.log(this.series.name);
  //     if (this.series.name !== 'Data Tags') {
  //       const Tagtxtime = Moment$(this.x).format(Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_1);
  //       const paramName = 'realtimepower';
  //       const paramValue = this.y ;
  //       const paramUnit = ' kW';
  //       setTagDetails()
  //     }
  //   }
  // };
  private setTagDetails = (
    tagtxtime: string,
    paramName: string,
    paramValue: string,
    paramUnit: string,
    loadType: string,
    flowChannelName: string
  ) => {
    this.tagParameters.siteID = this.siteId;
    this.displayUpdateTagAlert = false;
    if (loadType === 'ST_Graph') {
      this.tagParameters.paramName = paramName;
      this.tagParameters.time = tagtxtime;
      this.tagParameters.paramValue = paramValue;
      this.tagParameters.paramUnit = paramUnit;
      this.tagParameters.flowChannelName = flowChannelName;
    } else if (loadType === 'realTimeInfo') {
      this.tagParameters.paramName = paramName;
      this.tagParameters.time = tagtxtime;
      this.tagParameters.paramUnit = paramUnit;
      this.tagParameters.paramDisplayValue = paramValue + ' ' + paramUnit;
      this.tagParameters.paramValue = paramValue;
      this.tagParameters.flowChannelName = '';
    }
    // this.tagParameters.taggedBy = commonService.username; // Update later - Get from user logged in
    this.tagParameters.tagType = '';
    this.tagParameters.tagDescription = '';
    this.tagParameters.message = '';
    /* LoadId, loadname, LoadRID are set when graph drawing methods are called */
    this.tagParameters.rid = '';
  };
  private calTotalEnergyAndShow = (data: any, refreshTotalEnergy: boolean) => {
    let totalEnergy = ' ';
    if (data.length > 0 && refreshTotalEnergy == false) {
      let sumEnergy = 0;
      for (let i = 0; i < data.length; i++) {
        sumEnergy += data[i].y;
      }
      sumEnergy /= 60;
      const fromTime = dayjs(data[0].x).format(
        Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_1
      );
      const toTime = dayjs(data[data.length - 1].x).format(
        Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_1
      );
      // eslint-disable-next-line max-len
      totalEnergy =
        this.langData.energyTitle +
        fromTime +
        ' ' +
        this.langData.to +
        ' ' +
        toTime +
        ' ' +
        this.langData.is +
        Highcharts$.numberFormat(
          sumEnergy,
          Constants.DECIMAL_FORMAT.ZERO_DECIMAL,
          '.',
          ','
        ) +
        '(kWh)';
    }
    this.totalEnergy = totalEnergy;
  };
  private getAreaChartConfigOption = () => {
    const option = {
      chart: {
        defaultSeriesType: 'spline',
        zoomType: 'x',
        height: 585
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      yAxis: [
        {
          title: {
            text: this.langData.power,
            style: {
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          labels: {
            formatter: function () {
              return Highcharts$.numberFormat(
                this.value,
                Constants.DECIMAL_FORMAT.ZERO_DECIMAL,
                '.',
                ','
              );
            },
            style: {
              fontWeight: 'bold',
              fontSize: 12
            }
          },
          min: 0,
          softMax: 10
        },
        {
          id: 'DataTags',
          title: {
            text: ''
          },
          labels: {
            formatter: function () {
              return '';
            }
          },
          opposite: false
        }
      ],
      xAxis: {
        title: {
          text: this.langData.time,
          style: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        type: 'datetime',
        // labels: {},
        minRange: 10 * 1000,
        tickLength: 10,
        startOnTick: true,
        endOnTick: true,
        tickInterval: (3600 * 1000) / 2,
        pointInterval: (3600 * 1000) / 4,
        dateTimeLabelFormats: {
          hour: '%H:%M',
          year: '%Y',
          month: "%b '%y"
        },
        events: {},
        labels: {
          style: {
            fontWeight: 'bold',
            fontSize: 12
          }
        }
      },
      plotOptions: {
        series: {
          marker: {
            enabled: true
          },
          turboThreshold: 0,
          threshold: null,
          point: {
            events: {
              click: function (callback) {
                return callback;
              }
            }
          }
          // zoneAxis: 'x',
          // zones: [
          //   {
          //     value: 1659493816000,
          //     color: ''
          //   },
          //   {
          //     value: 1659532997000,
          //     color: 'red'
          //   }
          // ]
        }
      },
      series: [
        {
          name: this.langData.Power,
          showInLegend: true,
          data: []
        }
      ],
      tooltip: {
        shared: true,
        crosshairs: true,
        formatter: function () {
          // eslint-disable-next-line max-len
          let toolTipData =
            '<font style="font-size: 10px; fontWeight: bold">' +
            dayjs(this.x).format(
              Constants.MOMENT_DATE_FORMAT.FULL_DATE_TIME_FORMAT
            ) +
            '</font><br/>';
          for (let i = 0; i < this.points.length; i++) {
            const myPoint = this.points[i];
            // eslint-disable-next-line max-len
            let suffix =
              '<b><span style="color:' +
              myPoint.series.data[myPoint.point.index].color +
              '">\u25CF</span>   ' +
              myPoint.series.name +
              ': ' +
              Highcharts$.numberFormat(
                myPoint.y,
                Constants.DECIMAL_FORMAT.ZERO_DECIMAL,
                '.',
                ','
              ) +
              ' (kW)</b><br/>';
            if (myPoint.series.name.indexOf('Data Tags') !== -1) {
              // eslint-disable-next-line max-len
              suffix =
                '<span style="color:' +
                myPoint.series.data[myPoint.point.index].color +
                '">\u25CF</span>  ' +
                myPoint.series.name +
                ' : Present <br/>';
            }
            if (myPoint.series.name.indexOf('Fuel Consumption') !== -1) {
              // eslint-disable-next-line max-len
              suffix =
                '<span style="color:' +
                myPoint.series.data[myPoint.point.index].color +
                '">\u25CF</span>   ' +
                myPoint.series.name +
                ': ' +
                Highcharts$.numberFormat(
                  myPoint.y,
                  Constants.DECIMAL_FORMAT.DECIMAL_NO
                ) +
                ' (Litres)<br/>';
            }
            toolTipData += suffix;
          }
          return toolTipData;
        }
      }
      // exporting: {
      //   buttons: {
      //     contextButton: {
      //       menuItems: Highcharts$.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 2);
      //     }
      //   }
      // }
    };
    return option;
  };
  private onOpenAlertBox = (description: string) => {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = description;
  };
}
